import { css } from "styled-components";

export const h1_60_bold = css`
  font-family: Montserrat, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 68px;
  line-height: 68px;
`;

export const h2_44_bold = css`
  font-family: Montserrat, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 44px;
  line-height: 44px;
`;

export const h3_36_bold = css`
  font-family: Montserrat, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 36px;
`;

export const h4_24_bold = css`
  font-family: Montserrat, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
`;

export const p_20_semibold = css`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
`;

export const p_20_normal = css`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
`;

export const p_18_semibold = css`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
`;

export const p_18_medium = css`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;

export const p_18_normal = css`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
`;
export const p_16_semibold = css`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

export const p_16_medium = css`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;

export const p_16_normal = css`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
`;

export const p_14_medium = css`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`;

export const p_14_normal = css`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
`;

export const p_12_semibold = css`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
`;

export const p_12_medium = css`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
`;

export const p_12_normal = css`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
`;
